import { ScheduleSliceState } from '../index';
import { getDayFromState } from 'modules/schedule/store/utils/get-day-from-state';

export const markSelectedDay = (state: ScheduleSliceState) => {
  const weekDay = getDayFromState(state, state.selectedDate);
  if (weekDay) weekDay.isSelected = true;
};
